import { render, staticRenderFns } from "./VineyardSurveyPageEditor.vue?vue&type=template&id=3a3936c3&scoped=true&"
import script from "./VineyardSurveyPageEditor.vue?vue&type=script&lang=js&"
export * from "./VineyardSurveyPageEditor.vue?vue&type=script&lang=js&"
import style0 from "./VineyardSurveyPageEditor.vue?vue&type=style&index=0&id=3a3936c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3936c3",
  null
  
)

export default component.exports